import { Auth0Provider } from '@auth0/auth0-react'
import type { Auth0ProviderOptions } from '@auth0/auth0-react'
import type { ReactNode } from 'react'

type AuthContextProps = {
  children: ReactNode
}

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const audience = import.meta.env.VITE_AUTH0_AUDIENCE
const redirectHost = import.meta.env.VITE_AUTH0_REDIRECT_HOST

const handleRedirectCallback: Auth0ProviderOptions['onRedirectCallback'] = (
  appState,
) => {
  if (
    appState?.returnTo &&
    !['/', '/accounts', '/login-success', '/logout'].includes(appState.returnTo)
  ) {
    sessionStorage.setItem('returnTo', String(appState.returnTo))
  } else {
    sessionStorage.removeItem('returnTo')
  }
}

export const AuthContextProvider = ({ children }: AuthContextProps) => {
  if (!domain) {
    throw new Error('Missing Auth0 domain')
  }

  if (!clientId) {
    throw new Error('Missing Auth0 clientId')
  }

  if (!audience) {
    throw new Error('Missing Auth0 audience')
  }

  if (!redirectHost) {
    throw new Error('Missing Auth0 redirectHost')
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={`${redirectHost}login-success`}
      audience={audience}
      scope="read:current_user update:current_user_metadata heart"
      onRedirectCallback={handleRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}
